import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Stopwatch icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Stopwatch } from '@sravni/design-system-icons'
 *
 * <Stopwatch />
 * ```
 */
var Stopwatch = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Stopwatch", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.333 1.667h3.334M14.714 6.12a6.667 6.667 0 1 1-9.428 9.427 6.667 6.667 0 0 1 9.428-9.428Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M9.998 10.417a.417.417 0 1 0 .004.833.417.417 0 0 0-.004-.833ZM12.947 13.78a4.167 4.167 0 0 1-7.113-2.947c0-.259.03-.51.078-.754M7.05 7.883l2.658 2.659M16.667 4.167l-1.95 1.95M15.833 3.333 17.5 5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Stopwatch };
//# sourceMappingURL=Stopwatch.js.map
